import { useMemo } from "react";

export const usePhytosanitaryProgramTransform = (groupedData) => {
	return useMemo(() => {
		if (!groupedData || !Array.isArray(groupedData)) {
			return [];
		}

		const flatRows = [];

		groupedData.forEach((program) => {
			const {
				id,
				name,
				estate_parent_id,
				estate_parent_name,
				crop_id,
				crop_text,
				crop_detail_id,
				crop_detail_text,
				period_text,
				phenological_state_id,
				phenological_state_text,
				application_number,
				products = [],
				wetness,
				status_id,
				status_text,
				dealer_id,
				dealer_text,
				application_orders,
				application_order_type_name,
				application_order_type_id,
			} = program;

			if (!products || products.length === 0) {
				flatRows.push({
					application_orders: application_orders || [],
					status_id,
					status_text,
					id,
					name,
					estate_parent_id,
					estate_parent_name,
					crop_id,
					crop_text,
					crop_detail_id,
					crop_detail_text,
					period_text,
					phenological_state_id,
					phenological_state_text,
					objective_id: null,
					objective_text: "",
					application_number,
					product_id: null,
					product_text: "",
					product_code: "",
					unit_measure: "",
					type_detail: "",
					active_ingredient_text: "",
					dose_100l: null,
					dose_ha: null,
					dealer_id,
					dealer_text,
					wetness,
					observations: "",
					application_order_type_name: application_order_type_name || "",
					application_order_type_id: application_order_type_id || 0,
				});
			} else {
				products.forEach((product) => {
					flatRows.push({
						application_orders: application_orders || [],
						status_id,
						status_text,
						id,
						name,
						estate_parent_id,
						estate_parent_name,
						crop_id,
						crop_text,
						crop_detail_id,
						crop_detail_text,
						period_text,
						phenological_state_id,
						phenological_state_text,
						objective_id: product.objective_id,
						objective_text: product.objective_text || "",
						application_number,
						product_id: product.product_id,
						product_text: product.product_text || "",
						product_code: product.product_code || "",
						unit_measure: product.unit_measure || "",
						type_detail: product.type_detail || "",
						active_ingredient_text: product.active_ingredient_text || "",
						dose_100l: product.dose_100l,
						dose_ha: product.dose_ha,
						dealer_id: product.dealer_id || dealer_id,
						dealer_text: product.dealer_text || dealer_text,
						wetness,
						observations: product.observations || "",
						sub_group: product.sub_group || "",
						is_main_product: product.is_main_product || false,
						is_subgroup_optional: product.is_subgroup_optional || false,
						application_order_type_name: application_order_type_name || "",
						application_order_type_id: application_order_type_id || 0,
					});
				});
			}
		});

		return flatRows;
	}, [groupedData]);
};
